interface DeclarationRowProps {
  label: string;
  value: boolean | null;
  onChange: (v: boolean) => void;
  isExclusion?: boolean;
}

export default function DeclarationRow({ label, value, onChange }: DeclarationRowProps) {
  const yesActive = value === true;
  const noActive  = value === false;

  const btnBase: React.CSSProperties = {
    padding: '4px 14px', fontSize: 13, fontWeight: 700, borderRadius: 4,
    border: '1px solid var(--border)', cursor: 'pointer', minWidth: 48,
  };

  // Selected button gets a neutral blue highlight; unselected stays plain.
  const activeStyle: React.CSSProperties = {
    background: '#e8f0fe', color: '#1a56b0', borderColor: '#1a56b0',
  };
  const inactiveStyle: React.CSSProperties = {
    background: '#fff', color: 'var(--muted-foreground)',
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: 13, color: 'var(--primary)', flex: 1, lineHeight: 1.5 }}>{label}</span>
      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <button style={{ ...btnBase, ...(yesActive ? activeStyle : inactiveStyle) }} onClick={() => onChange(true)}>Igen</button>
        <button style={{ ...btnBase, ...(noActive  ? activeStyle : inactiveStyle) }} onClick={() => onChange(false)}>Nem</button>
      </div>
    </div>
  );
}
